import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17aab47d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "secondtab-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "node-font" }
const _hoisted_5 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_collapse_item = _resolveComponent("van-collapse-item")!
  const _component_van_collapse = _resolveComponent("van-collapse")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_collapse, {
      modelValue: _ctx.activeNames,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeNames) = $event))
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reqdata.deptTree, (item, index) => {
          return (_openBlock(), _createBlock(_component_van_collapse_item, { key: index }, {
            title: _withCtx(() => [
              _createElementVNode("div", null, [
                _createElementVNode("img", {
                  src: 
                require(`../../../assets/projectinfo-images/${_ctx.projectImages[index]}`)
              
                }, null, 8, _hoisted_5),
                _createElementVNode("span", null, _toDisplayString(item.nodeData.name) + "  (" + _toDisplayString(item.children.length) + ")", 1)
              ])
            ]),
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (li, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  class: "listnext"
                }, [
                  _hoisted_2,
                  _createElementVNode("div", {
                    style: {"display":"flex","justify-content":"space-between"},
                    onClick: ($event: any) => (_ctx.btnClick(li))
                  }, [
                    _createElementVNode("div", _hoisted_4, _toDisplayString(li.nodeData.name), 1),
                    _createVNode(_component_van_icon, { name: "arrow" })
                  ], 8, _hoisted_3)
                ]))
              }), 128))
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}